import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Element } from '../../../../../common/html/element'
import { Table } from '../../../../../common/table'
import { selectCompanyInfo } from '../../../../common/header/companyInfo/store/slice'
import { FilterTable } from '../../common/filterTable/FilterTable'
import { FinancialStatementsValueCell } from '../../common/table/FinancialStatementsValueCell'
import { MultiTHead } from '../../common/table/MultiTHead'
import { FirstColumnCell } from '../../common/table/firstColumnCell/FirstColumnCell'
import { AUDIT_STATUS, TYPE_OF_FS } from '../../constant'
import {
  changeAuditStatus,
  changeIncomeStatementIds,
  selectAuditStatuses,
  selectDataYears,
  selectGroupColumns,
  selectIncomeStatementChildIds,
  selectIncomeStatementIds,
  selectIncomeStatementItem,
  selectIncomeStatementParentId,
  selectIncomeStatementRowData,
  selectIsLoading,
  selectIsShowCommonSize,
  selectMethods,
  selectSource,
  selectTypeOfFS,
} from '../../store/slice'
import { financialStatementsOneYearTable } from '../../store/thunk'
import classes from './IncomeStatement.module.scss'

export const IncomeStatement = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const incomeStatementIds = useSelector(selectIncomeStatementIds)
  const groupColumns = useSelector(selectGroupColumns)
  const auditStatuses = useSelector(selectAuditStatuses)
  const methods = useSelector(selectMethods)
  const isLoading = useSelector(selectIsLoading)
  const isShowCommonSize = useSelector(selectIsShowCommonSize)
  const source = useSelector(selectSource)
  const typeOfFS = useSelector(selectTypeOfFS)
  const dataYears = useSelector(selectDataYears)

  const organizationIdParams = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  }).organizationId

  const companyInfo = useSelector(selectCompanyInfo)
  const companyType = companyInfo.companyType

  const onChangeAuditStatus = (e, year) => {
    const statusChange = auditStatuses.find((status) => status.year === year)
    const statusNotChange = auditStatuses.filter(
      (status) => status.year !== year,
    )
    const newAuditStatus = [
      ...statusNotChange,
      { year: year, isAudit: e.value === AUDIT_STATUS.audited.value },
    ]

    if (statusChange.isAudit !== (e.value === AUDIT_STATUS.audited.value)) {
      dispatch(
        financialStatementsOneYearTable({
          organizationId: Number(organizationIdParams),
          sourceOrganizationId: source.value,
          isConsolidated: typeOfFS.value === TYPE_OF_FS.consolidated.value,
          years: dataYears,
          auditStatuses: newAuditStatus,
          methods: methods,
        }),
      )
      dispatch(changeAuditStatus(newAuditStatus))
    }
  }

  return (
    <Element className={classes.container}>
      <FilterTable
        auditStatuses={auditStatuses}
        methods={methods}
        ids={incomeStatementIds}
      />
      <Element className={classes.tableContainer}>
        <Table
          ids={incomeStatementIds}
          noDataText={'common.NO_DATA'}
          getDataFromRedux={selectIncomeStatementItem}
          isLoading={isLoading}
          isNoDataWithHead={true}
          isDisplayScroll={false}
          renderTHead={() => (
            <MultiTHead
              tableTitle={groupColumns}
              tabName={'incomeStatements'}
              onChangeAuditStatus={onChangeAuditStatus}
            />
          )}
          schema={
            groupColumns[0]
              ? groupColumns[0].map((item, index) => {
                  const title = item.title
                  const colId = `${item.colId}`

                  const result = {
                    title,
                    colId,
                  }
                  if (index === 0) {
                    return {
                      ...result,
                      render: (val, { rowId }) => {
                        return (
                          <FirstColumnCell
                            ids={incomeStatementIds}
                            rowId={rowId}
                            val={val}
                            selectRowData={selectIncomeStatementRowData}
                            selectChildIds={selectIncomeStatementChildIds}
                            selectParentIds={selectIncomeStatementParentId}
                            changeIds={changeIncomeStatementIds}
                            tabName="incomeStatements"
                          />
                        )
                      },
                    }
                  }

                  return {
                    ...result,
                    render: (val, { locale }) => {
                      return (
                        <FinancialStatementsValueCell
                          val={val}
                          locale={locale}
                          isShowCommonYoY={isShowCommonSize}
                          tabName="incomeStatements"
                          companyType={companyType}
                          colId={colId}
                        />
                      )
                    },
                  }
                })
              : []
          }
        />
      </Element>
    </Element>
  )
}
